import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { AppService } from '../../app.service';
import { ActivateRequestModel, GetDeviceRequestModel } from '../confirmation/confirmation.model';

@Injectable()
export class ConfirmationService {

  constructor(private appService: AppService) { }

  getActivateCallRequest(deviceData, pnrFormData, devName): ActivateRequestModel {
    const activateUrl = ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token);
    let wifiActivateRequest;
    if (this.appService.isCharter) {
      wifiActivateRequest = {
        url: environment.apiBaseUrl + activateUrl,
        data: {
          'flightId': deviceData.flightId,
          'deviceName': devName,
          'passenger': {
            'firstName': pnrFormData.firstname,
            'lastName': pnrFormData.secondname,
            'email': pnrFormData.email
          }
        },
        headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
      }
    } else {
      wifiActivateRequest = {
        url: environment.apiBaseUrl + activateUrl,
        data: {
          'flightId': deviceData.flightId,
          'deviceName': devName,
          'passenger': {
            'firstName': pnrFormData.firstName,
            'lastName': pnrFormData.lastName,
            'bookingReference': pnrFormData.bookingReference
          }
        },
        headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
      }
    }
    return wifiActivateRequest;
  }

  getDeviceTypesRequest(passengerId): GetDeviceRequestModel {
    const requestEntity = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_DEVICE_TYPES.replace('<<passengerId>>', passengerId),
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    };
    return requestEntity;
  }

}
